import type { IGetProductsQuery } from "@magento/types/CodegenTypes";
import { ICurrencyEnum, IProductStockStatus } from "@magento/types/CodegenTypes";

export const getConfigurableProductResponseMock = (): IGetProductsQuery => ({
  currency: {
    base_currency_code: ICurrencyEnum.Eur,
    base_currency_symbol: "€",
  },
  products: {
    aggregations: [
      {
        attribute_code: "price",
        label: "Price",
        options: [
          {
            count: 1,
            label: "10-20",
            value: "10_20",
          },
        ],
      },
      {
        attribute_code: "category_uid",
        label: "Category",
        options: [
          {
            count: 1,
            label: "Acquista",
            value: "NDI=",
          },
          {
            count: 1,
            label: "Accessories",
            value: "NDY=",
          },
        ],
      },
      {
        attribute_code: "flavor",
        label: "Flavor",
        options: [
          {
            count: 1,
            label: "Gold",
            value: "13",
          },
          {
            count: 1,
            label: "Tan",
            value: "37",
          },
        ],
      },
      {
        attribute_code: "color",
        label: "Colour",
        options: [
          {
            count: 1,
            label: "Cantaloupe",
            value: "24",
          },
          {
            count: 1,
            label: "Black",
            value: "19",
          },
          {
            count: 1,
            label: "Dark Blue Classic",
            value: "31",
          },
          {
            count: 1,
            label: "Dark Blue",
            value: "26",
          },
          {
            count: 1,
            label: "Red",
            value: "29",
          },
        ],
      },
    ],
    items: [
      {
        sku: "20BD277000",
        __typename: "ConfigurableProduct",
        id: 86,
        product_disclaimer: "",
        name: "Fabric Carry Case",
        stock_status: IProductStockStatus.InStock,
        flavor: 0,
        flavor_label: "Kakao Flavor",
        color: 0,
        product_brand: "1",
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/static/version1732026409/frontend/Magento/luma/en_US/Magento_Catalog/images/product/placeholder/thumbnail.jpg",
        },
        subtitle: "",
        categories: [
          {
            name: "Acquista",
          },
          {
            name: "Accessories",
          },
        ],
        price_tiers: [],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 10,
                currency: ICurrencyEnum.Eur,
                multiplier: 1,
              },
              {
                value: 20,
                currency: ICurrencyEnum.Eur,
                multiplier: 2,
              },
              {
                value: 30,
                currency: ICurrencyEnum.Eur,
                multiplier: 3,
              },
              {
                value: 40,
                currency: ICurrencyEnum.Eur,
                multiplier: 4,
              },
              {
                value: 50,
                currency: ICurrencyEnum.Eur,
                multiplier: 5,
              },
            ],
            final_price: {
              value: 10,
              currency: ICurrencyEnum.Eur,
            },
            regular_price: {
              value: 19,
              currency: ICurrencyEnum.Eur,
            },
            discount: {
              percent_off: 47.37,
            },
          },
        },
        variants: [
          {
            product: {
              sku: "0000601",
              name: "Fabric Carry Case Cantaloupe",
              color: 24,
              stock_status: IProductStockStatus.InStock,
              flavor: 0,
              subtitle: "subtitle",
              product_disclaimer: "",
              color_label: "Cantaloupe",
              categories: [
                {
                  name: "Acquista",
                },
              ],
              price_range: {
                minimum_price: {
                  final_price: {
                    value: 10,
                    currency: ICurrencyEnum.Eur,
                  },
                  regular_price: {
                    value: 19,
                    currency: ICurrencyEnum.Eur,
                  },
                  discount: {
                    percent_off: 47.37,
                  },
                },
              },
            },
          },
          {
            product: {
              sku: "0000509",
              name: "Fabric Carry case Mint",
              color: 0,
              stock_status: IProductStockStatus.InStock,
              flavor: 37,
              color_label: "",
              subtitle: "subtitle",
              product_disclaimer: "",
              categories: [],
              price_range: {
                minimum_price: {
                  final_price: {
                    value: 16.8,
                    currency: ICurrencyEnum.Eur,
                  },
                  regular_price: {
                    value: 21,
                    currency: ICurrencyEnum.Eur,
                  },
                  discount: {
                    percent_off: 20,
                  },
                },
              },
            },
          },
          {
            product: {
              sku: "0000508",
              name: "Fabric Carry Case Black",
              color: 19,
              stock_status: IProductStockStatus.InStock,
              flavor: 0,
              color_label: "Black",
              subtitle: "subtitle",
              product_disclaimer: "",
              categories: [],
              price_range: {
                minimum_price: {
                  final_price: {
                    value: 19,
                    currency: ICurrencyEnum.Eur,
                  },
                  regular_price: {
                    value: 19,
                    currency: ICurrencyEnum.Eur,
                  },
                  discount: {
                    percent_off: 0,
                  },
                },
              },
            },
          },
          {
            product: {
              sku: "0000603",
              name: "Fabric Carry Case Dark Blue Classic",
              color: 31,
              stock_status: IProductStockStatus.InStock,
              flavor: 0,
              color_label: "Dark Blue Classic",
              subtitle: "subtitle",
              product_disclaimer: "",
              categories: [],
              price_range: {
                minimum_price: {
                  final_price: {
                    value: 19,
                    currency: ICurrencyEnum.Eur,
                  },
                  regular_price: {
                    value: 19,
                    currency: ICurrencyEnum.Eur,
                  },
                  discount: {
                    percent_off: 0,
                  },
                },
              },
            },
          },
          {
            product: {
              sku: "0000602",
              name: "Fabric Carry Case Dark Blue",
              color: 26,
              stock_status: IProductStockStatus.InStock,
              flavor: 0,
              color_label: "Dark Blue",
              subtitle: "subtitle",
              product_disclaimer: "",
              categories: [],
              price_range: {
                minimum_price: {
                  final_price: {
                    value: 19,
                    currency: ICurrencyEnum.Eur,
                  },
                  regular_price: {
                    value: 19,
                    currency: ICurrencyEnum.Eur,
                  },
                  discount: {
                    percent_off: 0,
                  },
                },
              },
            },
          },
          {
            product: {
              sku: "0000604",
              name: "Fabric Carry Case Red1",
              color: 29,
              stock_status: IProductStockStatus.OutOfStock,
              flavor: 13,
              color_label: "Red",
              subtitle: "subtitle",
              product_disclaimer: "",
              categories: [],
              price_range: {
                minimum_price: {
                  final_price: {
                    value: 19,
                    currency: ICurrencyEnum.Eur,
                  },
                  regular_price: {
                    value: 19,
                    currency: ICurrencyEnum.Eur,
                  },
                  discount: {
                    percent_off: 0,
                  },
                },
              },
            },
          },
        ],
        media_gallery: [],
        flavour_details: [],
      },
    ],
  },
});
